import { useLayoutEffect } from "react";
import { useCurrentUser } from "./api/userGetters";
import { useTheme } from "./ThemeProvider";

export const UserThemeSetter = () => {
    const user = useCurrentUser();
    const { setTheme } = useTheme();

    const theme = user.theme;
    useLayoutEffect(() => {
        setTheme(theme);
    }, [theme, setTheme]);

    return <></>;
};
